export const parseQuery = <T>(query: string | null | undefined, defaultValue: T): T => {
  if (!query) return defaultValue

  try {
    return JSON.parse(query) as T
  } catch {
    return defaultValue
  }
}
